import React from 'react';
import { FormControl, TextField } from '@mui/material';
import trLocale from 'date-fns/locale/tr';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { InputformatDate } from '../util/DateUtil';
import { Controller } from 'react-hook-form';

const DateInput = React.forwardRef(({
    name,
    label,
    defaultValue,
    onChange,
    control,
    error,
    rules,
    variant = 'outlined',
    margin = 'dense',
    inputFormat = "dd.MM.yyyy",
    isDateTime = false, // Add this flag to toggle between DatePicker and DateTimePicker
    ...props
}, ref) => {

    // Choose either DatePicker or DateTimePicker based on the flag
    const PickerComponent = isDateTime ? DateTimePicker : DatePicker;

    return (
        <FormControl fullWidth variant={variant} margin={margin}>
            <Controller
                name={name}
                control={control}
                fullWidth
                defaultValue={defaultValue}
                rules={rules}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                        <PickerComponent
                            {...props}
                            label={label}
                            value={value}
                            onChange={(newValue) => onChange(InputformatDate(newValue))}
                            inputFormat={inputFormat}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    error={!!error}
                                    margin={margin}
                                    variant={variant}
                                    helperText={error?.message}
                                    autoComplete="off"
                                />
                            )}
                        />
                    </LocalizationProvider>
                )}
            />
        </FormControl>
    );
});

export default DateInput;
